{
  "fr": {
    "constants": {
      "address": {
        "city": "Ville",
        "country": "Pays",
        "number": "Numéro",
        "street": "Rue",
        "zip": "Code postal"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "days": ["di", "lu", "ma", "mer", "je", "ve", "sa"],
      "languages": {
        "de": "Allemand",
        "en": "Anglais",
        "fallback_info": "Il semble que ce message ne soit pas disponible dans votre langue. Nous utilisons à la place la traduction {fallback_locale} existante.",
        "fr": "Français",
        "nl": "Néerlandais",
        "pl": "Polonais",
        "pt": "Portugais"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Impérial",
        "metric": "Métrique",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "profile_statuses": {
        "active": "Actif",
        "added": "Sans invitation",
        "blocked": "Déactivé",
        "discarded": "Supprimé",
        "invited": "Invité",
        "invited_at": "Invité"
      },
      "profile_statuses_descriptive": {
        "active": "Dernière fois actif sur la plateforme: {session_ended_at}",
        "added": "Pas encore invité",
        "blocked": "Déactivé",
        "discarded": "Supprimé",
        "invited": "Invité mais pas encore inscrit",
        "invited_at": "Invité {invited_at}. Pas encore inscrit"
      },
      "profile_titles": {
        "dr": "Docteur",
        "mr": "Monsieur",
        "mrs": "Madame",
        "professor": "Professeur",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Jours",
        "months": "Mois",
        "weeks": "Semaines"
      },
      "time_units_count": {
        "days": "pas de jour | jour | jours",
        "months": "pas de mois | mois | mois",
        "weeks": "pas de semaine | semaine | semaines"
      },
      "timezones": {
        "America/Chicago": "Amérique/Chicago",
        "America/Denver": "Amérique/Denver",
        "America/Los_Angeles": "Amérique/Los Angeles",
        "America/New_York": "Amérique/New York",
        "Europe/Brussels": "Europe/Bruxelles",
        "Europe/Lisbon": "Europe/Lisbonne",
        "Europe/London": "Europe/Londres",
        "Europe/Madrid": "Europe/Madrid"
      },
      "wind_orientations": {
        "east": "Est",
        "north": "Nord",
        "northeast": "Nord-Est",
        "northwest": "Nord-Ouest",
        "select": "Sélectionner Orientation",
        "south": "Sud",
        "southeast": "Sud-Est",
        "southwest": "Sud-Ouest",
        "west": "Ouest"
      }
    }
  }
}
